import type { Meta, StoryObj } from "@storybook/react";

import type { GreetingCardProps } from "@/ui/components/home/GreetingCard";
import { GreetingCard } from "@/ui/components/home/GreetingCard";
import { Box } from "@/ui/layout";

const StoryMeta: Meta<GreetingCardProps> = {
  title: "Components/Home/Greeting Card",
  component: GreetingCard,
  argTypes: {
    message: { control: "text" },
    onHelpPress: { action: "Help pressed" },
    userName: { control: "text" },
  },
  args: {
    message: "Welcome to your Equip account, your home for all things Equip.",
    userName: "John",
  },
  render: (props) => (
    <Box
      height={300}
      justifyContent="center"
      left={0}
      position="absolute"
      right={0}
      top={0}
    >
      <GreetingCard {...props} />
    </Box>
  ),
};

type Story = StoryObj<GreetingCardProps>;

const Primary: Story = {};

const MissingUserName: Story = {
  args: {
    userName: undefined,
  },
};

const EmptyUserName: Story = {
  args: {
    userName: "",
  },
};

export { EmptyUserName, MissingUserName, Primary };
export default StoryMeta;
